<!--
 * @Author: zl
 * @Date: 2022-09-15 15:33:55
 * @LastEditTime: 2022-09-16 16:02:23
 * @LastEditors: zl
 * @Description: 现场踏勘记录
-->
<template>
	<div class='SiteExplorationLog-layout'>
		<el-row>
			<el-col :span="22"
					:offset="1">
				<h2 class="text-center mb30">现 场 踏 勘 记 录 表</h2>
				<el-descriptions :column="2"
								 size="small"
								 border
								 class="custom-descriptions">
					<el-descriptions-item label="工程项目名称"
										  :span="2">{{ currentObj.proName }}</el-descriptions-item>
					<el-descriptions-item label="关联审计任务"
										  :span="2">{{ form.taskName }}</el-descriptions-item>
					<el-descriptions-item label="建设单位"
										  :span="2">{{ form.conUnitName }}</el-descriptions-item>
					<el-descriptions-item label="施工单位"
										  :span="2">{{ form.roadworkUnitName }}</el-descriptions-item>
					<el-descriptions-item label="监理单位"
										  :span="2">{{ form.superviseUnit }}</el-descriptions-item>
					<el-descriptions-item label="其他单位"
										  :span="2">{{ form.otherUnit }}</el-descriptions-item>
					<el-descriptions-item label="记录表名称">{{ form.otherUnit }}</el-descriptions-item>
					<el-descriptions-item label="踏勘组织人">{{ form.organizerName }}</el-descriptions-item>
					<el-descriptions-item label="踏勘时间">{{ form.investTime }}</el-descriptions-item>
					<el-descriptions-item label="踏勘地点">{{ form.investPlace }}</el-descriptions-item>
					<el-descriptions-item label="踏勘名单"
										  :span="2">
						{{ form.investListName }}
					</el-descriptions-item>
					<el-descriptions-item label="记录内容"
										  :span="2"
										  contentClassName="h200">
						<div class="quill-editor editor w100">
							<div class="ql-container">
								<div class="ql-editor">
									<div class="content"
										 v-html="form.content"></div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item label="上传附件"
										  :span="2">
						<myUpload listType="list"
								  tableName="audit_invest_record"
								  uploadType="2"
								  assortment="test3"
								  width="auto"
								  height="auto"
								  :aid="form.id"
								  mode="view"
								  class="h100 w100"></myUpload>
					</el-descriptions-item>
				</el-descriptions>
			</el-col>
		</el-row>
	</div>
</template>

<script>
import * as API from '@/api/AuditReport/AuditReport'
export default {
	props: {
		currentObj: {
			type: Object,
			default: () => {
				return {}
			},
		},
	},
	components: {},
	data() {
		return {
			form: {},
		}
	},
	created() {
		// 获取详情
		this.getDetails()
	},
	mounted() {},
	methods: {
		// 获取详情
		getDetails() {
			API.selectInvestRecordDetail({
				id: this.currentObj.id,
			}).then((res) => {
				this.form = res.data
			})
		},
	},
	computed: {},
}
</script>

<style lang='less' scoped>
</style>